export default __webpack_public_path__ + "static/media/img-0612-monaco-full-face.3d9ddfd1.png";